module.exports = __webpack_public_path__ + "static/spcrmbg.07087a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/spcrmbg.jpg
// module id = 1379
// module chunks = 39761248111596 199180123508537